import { Component, ElementRef, Input, Renderer2 } from '@angular/core';
import { GlobalUtilityService } from '@AppCore/services/global-utility.service';

@Component({
  selector: 'app-infinite-scroller',
  templateUrl: './infinite-scroller.component.html',
  styleUrls: ['./infinite-scroller.component.scss'],
})
export class InfiniteScrollerComponent {
  @Input() speed: 'slow' | 'medium' | 'fast' = 'medium';
  animationClass: string = '';
  ngOnInit() {
    // Set animation speed based on input

    let isMobile = this.globalUtilityService.isMobile();
    if (isMobile) {
      this.animationClass = `animate-scroll-fast`;
    } else {
      this.animationClass = `animate-scroll-medium`;
    }
  }

  constructor(
    private renderer: Renderer2,
    private elementRef: ElementRef,
    private globalUtilityService: GlobalUtilityService
  ) {}
}
